import React from 'react';

import Tooltip from '@mui/material/Tooltip';
import AutorenewIcon from '@mui/icons-material/Autorenew';
import VerifiedIcon from '@mui/icons-material/Verified';
import PendingIcon from '@mui/icons-material/Pending';

export default function MintingStatusIcon({ status }) {
	const checkStatus = () => {
		if (status === 'minted') {
			return { icon: <VerifiedIcon className="text-green w-[18px]" />, title: 'NFT Minted' };
		}

		if (status === 'minting') {
			return { icon: <AutorenewIcon className="text-orange w-[18px]" />, title: 'NFT Minting In-progess' };
		}

		if (status === 'pending') {
			return {
				icon: <PendingIcon className="text-yellow w-[18px]" />,
				title: 'NFT Minting Pending'
			};
		}
	};

	const statusInfo = checkStatus();

	return (
		<Tooltip
			placement="top"
			title={statusInfo?.title}
		>
			{statusInfo?.icon}
		</Tooltip>
	);
}
